module.exports = __webpack_public_path__ + "img/day2-selected.6f7835d4.svg";